import { http } from '@/utils/http'
export interface IFooItem {
  id: string
  name: string
}
// 查询天气
export const showWeather = (data) => {
  return http.get<IFooItem>('/wxapp/home/showWeather', data)
}
// 搜索
export const homeSearch = (data) => {
  return http.get<IFooItem>('/wxapp/home/search', data)
}
// 首页卡片
export const homeTravelCard = (data) => {
  return http.get<IFooItem>('/wxapp/home/homeTravelCard', data)
}
// 广告
export const getAd = (data) => {
  return http.get<IFooItem>('/wxapp/getAd', data)
}
// 云闪付联登
export const cloudLogin = (data) => {
  return http.post<IFooItem>('/unionCloud/login/cloudLogin', '', data)
}
// 0息游联登
export const shopLogin = (data) => {
  return http.post<IFooItem>('/wxapp/shopLogin', '', data)
}
